import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, watch } from "vue";

import DsTopSlotHeadlineSubheadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import DsBottomSlotActionBar from "@sazka/design-system/src/bottom-slot/ds-bottom-slot-action-bar.vue";

import { bonImgUrl } from "../../utils/image-src";

import useBonusomatData from "../../composables/use-bonusomat-data";
import { useStackedModals } from "@sazka/utils/composables/use-stacked-modals";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-quests-confirm-modal',
  setup(__props) {

const { lastActivatedQuestId, isQuestConfirmOpen, isActiveQuestCancelable, activateQuest, deactivateQuest } =
    useBonusomatData();
const { addToStackedModals, removeFromStackedModals } = useStackedModals();

const headline = computed(() =>
    lastActivatedQuestId.value ? "Opravdu chcete aktivovat jiný Quest?" : "Opravdu chcete ukončit Quest?"
);
const headlineImg = computed(() =>
    lastActivatedQuestId.value ? bonImgUrl("board/mr-green", "png") : bonImgUrl("quests/mr-red-cancel-quest", "png")
);
const headlineImgAlt = computed(() =>
    lastActivatedQuestId.value ? "Pan Zelený na černém pozadí" : "Pan Červený na černém pozadí"
);
const description = computed(() =>
    isActiveQuestCancelable.value
        ? "K rozehranému Questu se můžete kdykoliv vrátit."
        : "K " +
          (lastActivatedQuestId.value ? "aktuálně" : "tomuto") +
          " rozehranému Questu se <span style='color: red; font-weight: bold;'>nebudete</span> moct vrátit."
);
const btnSubmitText = computed(() => (lastActivatedQuestId.value ? "Ano, aktivovat" : "Ano, ukončit"));

const closeModal = () => {
    isQuestConfirmOpen.value = false;
};

watch(
    isQuestConfirmOpen,
    (newIsQuestConfirmOpen, oldIsQuestConfirmOpen) => {
        if (newIsQuestConfirmOpen) {
            addToStackedModals();
        } else if (oldIsQuestConfirmOpen) {
            removeFromStackedModals();
        }
    },
    {
        immediate: true,
    }
);

const submitHandler = async () => {
    closeModal();

    if (lastActivatedQuestId.value) {
        await activateQuest(lastActivatedQuestId.value, true);
    } else {
        await deactivateQuest(null, true);
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsModalDialog, {
    modelValue: _unref(isQuestConfirmOpen),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isQuestConfirmOpen) ? (isQuestConfirmOpen).value = $event : null)),
    "css-class": "bonusomat-quests-confirm-modal",
    theme: "dark",
    "bottom-divider-visible": false
  }, {
    top: _withCtx(() => [
      _createVNode(DsTopSlotHeadlineSubheadline, {
        headline: headline.value,
        subheadline: description.value,
        "image-src": headlineImg.value,
        "image-alt": headlineImgAlt.value
      }, null, 8, ["headline", "subheadline", "image-src", "image-alt"])
    ]),
    bottom: _withCtx(() => [
      _createVNode(DsBottomSlotActionBar, {
        theme: "dark",
        size: "sm",
        "btn-submit-type": "error",
        "btn-submit-text": btnSubmitText.value,
        "btn-close-text": "Storno",
        onSubmitDialog: submitHandler,
        onCloseDialog: closeModal
      }, null, 8, ["btn-submit-text"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})